export default {
  global: {
    parentTitle: 'Parent Portal',
    enter: 'Enter',
    back: 'Back',
    next: 'Next',
    backToSchedule: 'Back to Schedule page',
    backToCourse: 'Back to Course page',
    error: 'An error occurred.',
    trtAgain: 'Please try again.',
    noData: 'No Data',
    hLogo: 'LIVE Online',
    hLogoempty: 'AfterSchool Program',
    hPhoneNum: 'Phone Number',
    hDownload: 'Get Free Lesson!',
    select:'+1 U.S.A',
    name: 'kid(s) Nickname',
    phone: 'Phone Number',
    plase:'Phone Number',
    email: 'Email Address',
    wechat: 'WeChat ID',
    submit:'Submit',
  },
  index: {
    timeZone: 'Eastern Standard Time',
    profile: 'Profile',
    phone: 'Phone no.',
    location: 'Location',
    email: 'Email',
    referrer: 'Referrer',
    creditBalance: 'Credit Balance',
    topUp: 'Top Up',
    viewDetails: 'View Details',
    myChild: 'My Student',
    ofBirth: 'Date of Birth',
    editChild: 'Edit Student'
  },
  searchTabBar: {
    selectChild: 'Select Student',
    all: 'All',
    Showing: 'Showing:',
    scheduled: 'Scheduled Lesson',
    course: 'Course',
    completedLesson: 'Completed Classes'
  },
  tabBar: {
    noLesson: 'No classes scheduled.',
    download: '',
    downloadAppStore: 'Download on App Store',
    downloadGooglePlay: 'Download on Google Play'
  },
  login: {
    currentPassword: 'Current password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    enterPassword: 'Enter password',
    confirmPassword: 'Confirm password',
    reset: 'Reset',
    savedPsw: 'New password is saved',
    backSign: 'Back to Sign In page',
    currentPasswordPlaceholder: 'Enter current password',
    newPasswordPlaceholder: 'Enter new password',
    confirmPasswordPlaceholder: 'Confirm new password'
  },
  auth: {
    slogan: 'Help children learn authentic Chinese with ease',
    subtitle: 'Graded native-style Chinese courses for ages 3–18: listen and speak first, then read and write, with fun picture-book animation classes',
    codeLoginTab: 'Verification code',
    passwordLoginTab: 'Password',
    loginTitle: 'Sign in',
    phonePlaceholder: 'Enter phone number',
    codePlaceholder: 'Enter verification code',
    passwordPlaceholder: 'Enter password',
    login: 'Sign in',
    termsLogin: 'By signing in, you agree to the',
    saveNewPassword: 'Save new password'
  },
  signIn: {
    signIn: 'Sign In',
    register: 'Register',
    enterInfo: 'Enter your phone number to register',
    sentCode: 'A code will be sent to verify your phone.',
    phone: 'Phone Number',
    code: 'Send Code',
    verifiCode: 'Verification Code',
    repeatVerifiCode: 'Resend Code',
    second: 's',
    enter: 'Enter',
    enterPsw: 'Sign in with password',
    password: 'Password',
    forgetPassword: 'Forgot password',
    signIncode: 'Register/Sign in with verification code',
    searchArea: 'Search Area Code'
  },
  header: {
    resetPassword: 'Reset Password',
    logout: 'Logout',
    setting: 'Settings'
  },
  main: {
    topic: 'Lesson Topic:',
    attendee: 'Attendee:',
    viewFeedback: 'View Feedback',
    leaveFeeback: 'Parent Evaluation',
    teacherComments: 'Teacher Comments',
    rating: 'Your Rating:',
    comment: 'Your Comment:',
    commentHere: 'Type your comment here',
    send: 'Send',
    sendSuccess: 'Feedback comment successful.',
    enterClassRoom: 'Enter Class',
    PresentationPreview: 'Presentation Preview',
    requestLeave: 'Cancelling A Course',
    leave: 'Leave',
    beginToEnter: 'Class will be opened 5 minutes before scheduled time.',
    timeOut: 'Start in ',
    timeOut_1:'',
    OnAir:'On Air',
    inProgress: 'In progress',
    noStart: 'Not Started',
    completed: 'Completed',
    cancel: 'Cancel',
    hours: ' hours ',
    hr:' hour ',
    mins: ' mins',
    sickTitle: 'Cancelling A Course',
    askTo: 'Are you sure you want to request a leave for ',
    currentCredit: ' ?',
    subject: 'Subject',
    date: 'Date',
    time: 'Time',
    confirmSick: 'Confirm Lave'
  },
  course: {
    nextLesson: 'Next Class Time',
    viewCurriculum: 'View Curriculum',
    title: 'Course Curriculum',
    subjectDescription: 'Subject Description',
    levels: 'Levels',
    best: 'Best for',
    yearold: 'years old',
    lessonTopic: 'Lesson Topics',
    totalLesson: 'No. of lesson:'
  },
  email: {
    accountInfo: 'Account information',
    emailAddress: 'Email Address',
    referralCode: 'Referral Code (Optional)',
    entercode: 'Enter code',
    ParentFullName: 'Kid(s) Nickname',
    WechatID:'Wechat ID',
    nowechatname:'(no wechat name)',
    ReferredByFriend:'Referred by a friend?',
    FriendReferralPrograms:'Friend Referral Programs',
    EnterYourReferralCode:'Enter Your Referral Code',
    EnterCode:'Enter code',
    fail:'Recommendation code verification failed'


  },
  myChild: {
    addProfile: 'Add Profile',
    pickAvatar: 'Pick an Avatar',
    childName: 'Student Name',
    childBirth: 'Student Birthday',
    deleteChild: 'Delete Student',
    editProfile: 'Edit Profile',
    saveChange: 'Save Change',
    add: 'Add',
    edit: 'Edit',
    select: 'Select',
    name: 'Name',
    editChildProfile: 'Edit Student Profile',
    addChild: 'Add Student',
    editChild: 'Edit Profile',
    whoAttend: 'Who will be attending our lessons?',
    minimumChild: 'Mimimum 1 profile must be added to proceed.',
    sureToLeave: 'Are you sure to leave without saving your input?',
    sureToDelete: 'Are you sure to delete ',
    sureToWho: '’s Profile?',
    yes: 'Yes',
    no: 'No, go back',
    Next:'Next',
  },
  payment: {
    paySuccess: 'Payment Successful',
    payment: 'Payment',
    detail: 'Detail',
    price: 'Price:',
    credits: 'Credits:',
    backMain: 'Back to Main Page',
    hpayment: 'Payment',
    hdetail: 'Detail',
    hcredits: 'Credits:',
    hPayPlease: '*Please close the website',
    hPayGoBack: 'and go back to Panda Mandarin app',
    hPaySeeBalance: 'to see your new balance!'
  },
  payList: {
    creditTitle: 'Credit History',
    paymentTitle: 'Payment History',
    total: 'Total Credit Balance',
    date: 'Select a date',
    range: 'date range',
    dash: '/',
    reset: 'Reset filter',
    dateTitle: 'Date',
    description: 'Description',
    credits: 'Credit(s)',
    orderNo: 'Order no.',
    paid: 'Paid ($)'
  },
  recharge: {
    topup: 'Top Up Credits',
    currentCredit: 'My Current Credit Balance',
    manyCredit: 'How many credits woud you like to purchase?',
    selectPackage: 'Select a package below.',
    toPay: 'Proceed to Payment',
    empty: 'for',
    credits: 'credits',
    extra: 'Extra',
    free: 'free',
    hCurrentCredit: 'My Current Credit Balance:',
    hPay: 'Pay',
    hExtraCredits: ' extra credits ',
    hFree: 'FREE'
  },
  errorprompt: {
    selectAvatar: 'Please select avatar.',
    selectBirthday: 'Please select Student Birthday.',
    selectName: 'Please enter Student Name.',
    selectChild: 'Please select students.',
    phoneEmpty: 'Phone number cannot be empty.',
    phoneError: 'The phone number format is not correct.',
    nameEmpty: 'The parent full name cannot be empty.',
    wechatEmpty: 'The Wechat ID cannot be empty.',
    emailEmpty: 'The Email cannot be empty.',
    emailError: 'The Email format is not correct.',
    referralError: 'The Referral Code format is not correct.',
    emailBeSend: 'The email has been sent',
    passwordEmpty: 'The password cannot be empty.',
    passwordLessThan: 'The password must consist of at least seven digits and letters',
    passwordError: 'The password format is not correct.',
    currentpswEmpty: 'Current password cannot be empty.',
    currentpswError: 'Current password format is not correct.',
    newPswEmpty: 'New password cannot be empty.',
    newPswSameAs: 'New password cannot be the same as current password.',
    newPswError: 'New password format is not correct.',
    newPswDontSame: 'Both new passwords do not match.',
    del_1:'Are you sure to delete?',
    del_2:'Deleted successfully',
    del_3:'Confirm',
    del_4:'Cancel',
  },
  test2: {
    Next_class: 'Next Class Time',
    meet: 'MEET',
  },
  new_header:{
    Unlimited: 'Unlimited',
    information: 'Parent User Profile',
    TransactionOrderHistory: 'Payment Orders',
    MonthlyPassUser: 'Monthly Pass User',
    MonthyuStatement: 'Lesson Usage Details',
    Log_out: 'Log out',
    Expires: 'Expires',
    UserAgreement: 'User Agreement',
    totalCredit: 'Total Credits',
    purchasedCredit: 'Purchased Credits',
    rewardCredit: 'Reward Credits',
    recharge: 'Top Up',
  },
  new_index:{
    home: 'Home',
    CurrentMonthLessons:'Lessons Booked This Month',
    Completed:'Classes Completed',
    Scheduled:'Pending',
    NoShow:'No Show',
    Remaining:'Remaining',
    HelloParent:'Hello, parent of {name}!',
    editInfo:'Edit Information',
    Attend_Class_Now: 'Live Classes',
    Class_Enrolled: 'Series Courses',
    View_Completed_Lessons: 'Completed Classes',
    Schedule_a_Class: 'Schedule a Class',
    Purchase_Lesson_Plan: 'Purchase Lesson Plan',
    Dear_customer:'Dear customer ',
    If:'If you would like to change your plan.' ,
    Please:'Please contact our customer service.',
    Address:'Address message',
    Videoclass:'Video Class',
    Homework:'Homework',
    changeCurrentChildren:'Select Student'
  },
  new_test1:{
    In_progress: 'In progress',
    Level: 'LEVEL',
    Topic: 'TOPIC',
    Type: 'CLASS TYPE',
  },
  new_test2:{
    Class_Enrolled: 'Course',
    In_progress: 'In progress',
    Not_Started: 'Not Started',
    Completed:'Completed',
    Level: 'LEVEL',
    Topic: 'TOPIC',
    Student: 'Student'
  },
  new_test3:{
    Level:'LEVEL',
    Topic:'TOPIC'
  },
  new_test4:{
    Schedule_a_Class:'Schedule a Class',
    Sch_content:'You also can find our live chat on Panda Mandarin parent APP for more informations.',
    Mandy:'Mandy',
    your:'Your course advisor',
    Wechat_ID: 'Wechat ID'
  },
  new_test5:{
    Pick_a_Plan: 'Pick a Plan',
    Number_of_Kids: 'Number of Kids',
    Pay_as_You_Go: 'Pay-as-You-Go',
    Continue: 'Continue',
    sessions:'sessions'
  },
  information:{
    Profile: 'Profile',
    Parent_Full_Time: 'Parent Full Name',
    Phone_no: 'Phone No',
    Location: 'Location',
    Email: 'Email',
    Password: 'Password',
    Change: 'Change',
    Preferred_language:'Preferred language',
    editProfile: 'editProfile',
    English:'English',
    Simplified_Chinese:'中文（简体）'
  },
  Transaction: {
    History:'Payment Orders',
    Order: 'Order No.',
    Date: 'Date',
    Description:'Class Hour',
    Paid:'Paid ($)',
    Status:'Status',
    Contract: 'Contract',
    PaidCreditLabel: 'Paid Credit',
    FreeCreditLabel: 'Free Credit',
    ViewContract: 'View Contract',
  },
  MonthlyPassUser: {
    Monthly_Pass_User: 'Monthly Pass User',
    Pass_Information:'Pass Information',
    kid:'kid(s)',
    Month:'month',
    Pass_Expires:'Pass Expires',
    Next_billing_date: 'Next Billing Date',
    view_charges: 'view charges',
    view_billing_history: 'view billing history',
    Payment_method: 'Payment Method',
    Mastercard_ending_in: 'Mastercard ending in',
    Update:'Update',
    Expires:'Expires',
    Changing:'Changing plan? Contact your Course advisor for assistance.',
    Wechat_ID: 'Wechat ID'
  },
  addChildren:{
    Edits:'Switch Student',
    Childs_Name: 'Student Name',
    Child_Birthday: 'Student Birthday',
    add:'Add Student',
    addNew:'Add New Student',
    breadcrumbHome:'Home',
    breadcrumbEdit:'Edit Information',
    Delete:'Delete',
    Edit:'Edit'
  },
  Change_Plan:{
    ChangePlan:'Change Plan',
    Current_Plan: 'Current Plan',
    year:'year',
    month:'month',
    New_Plan:'New Plan',
    Payment_method:'Payment method',
    Mastercard:'Mastercard ending in',
    Update: 'Update',
    Expires:'Expires',
    Change_Plan:'Change Plan',
    Months:'Months',
    kids:'kid(s)',
    What:'What happens next',
    Change_Plan: 'Change Plan'
  },
  homework: {
    selectMonth: 'Select Month',
    homeworkTime: 'Assignment period: {start} to {end}',
    preview: 'Preview',
    download: 'Download',
    viewHomework: 'View Homework',
    viewWord: 'Study Document',
    viewVideo: 'View Video',
    listenAudio: 'Listen to Audio',
    myAnswer: 'My Answer',
    enterContent: 'Please enter content',
    addImage: 'Add Image',
    addDocument: 'Add Document',
    addVideo: 'Add Video',
    addAudio: 'Add Audio',
    fileSizeLimit: '(Max file size: 10MB)',
    fileSizeLimitMedia: '(Max file size: 500MB)',
    clickUpload: 'Upload',
    transcoding: 'Transcoding...',
    saveDraft: 'Save as Draft',
    submitHomework: 'Submit',
    recallAndEdit: 'Recall & Edit',
    myHomework: 'My Homework',
    teacherReview: 'Reviewed by {name}',
    emptyMonth: 'No assignments this month. Try another month.',
    uploading: 'Uploading... {progress}%',
    fileTypeError: '{name}: invalid file type. Only {accept} files are allowed.',
    fileSizeError: '{name}: file exceeds the 10MB size limit.',
    fileSizeErrorMedia: '{name}: file exceeds the 500MB size limit.',
    mediaPreviewError: 'Unable to play in the preview player. Opened in a new tab instead.',
    emptySubmitError: 'Nothing to save or submit. Please add your answer first.',
    status: {
      notSubmitted: 'Unsubmitted',
      submitted: 'Submitted',
      reviewed: 'Reviewed',
      draft: 'Draft',
      ended: 'Ended',
    },
    score: {
      fail: 'Fail',
      fair: 'Fair',
      medium: 'Average',
      good: 'Good',
      excellent: 'Excellent',
    }
  },
  videoClass: {
    title: 'Video Class',
    breadcrumb: 'Video Class / Course Detail',
    selectMonth: 'Select Month',
    emptyMonth: 'No video classes this month. Try another month.',
    statusLabel: 'Status',
    classTime: 'Class Time',
    anytime: 'Learn Anytime',
    learned: 'Progress',
    intro: 'Introduction',
    introColon: 'Introduction:',
    lastViewed: 'Last Viewed',
    continueLearning: 'Continue GO!',
    startLearning: 'Start Learning GO!',
    courseCatalog: 'Course Catalog',
    courseInfo: 'Course Details',
    chapterLessons: '({count} lessons)',
    video: 'Video',
    courseCover: 'Course Cover',
    chapterCover: 'Chapter Cover',
    studying: 'In Progress',
    lastStudy: 'Last',
    status: {
      notStarted: 'Not Started',
      inProgress: 'In Progress',
      completed: 'Completed',
    }
  },
  Monthly:{
    Monthlys:'Lesson Usage Details',
    Date:'Date',
    studen:'Student(s)',
    class:'class',
    Class_size:'Class size',
    Credit:'Credit(s)',
    Requried:'Requried Credit(s)',
    Status:'Status',
    yue:'Select Date',
    CreditType: 'Credit Type',
    FreeCredit: 'Free Credit',
    PaidCredit: 'Paid Credit',
    Detail: 'Detail',
  },
  Payment:{
    Complete:'Complete Payment',
    Go_Back: 'Go Back',
    Personal_Infomation:'Personal Infomation',
    Payment_Method:'Payment Method',
    Pay_Now:'Pay Now',
    describe:'By continuing, I accept terms in the <span style="color:#4B69FE;text-decoration:underline;">Service Payment Agreement</span> including <span style="color:#4B69FE;text-decoration:underline;">Refund Policy</span>. I have read the <span style="color:#4B69FE;text-decoration:underline;">COPPA Direct Notice to Parent</span>. I agree to subscribe to Panda Mandarin newsletter, SMS messages, and accept the <span style="color:#4B69FE;text-decoration:underline;">Terms of Use</span> and <span style="color:#4B69FE;text-decoration:underline;">Privacy Policy</span>.',
  },
  pay_Success:{
    Go_Home: 'Go Home',
    Payment:'Payment successfull!',
    We:'We will contact you shortly.',
    You:'You will receive a confirmation email shortly.',
    Below: 'Below are the contact information for your course advisor Mandy.',
    Total: 'Total Today',
    month:'month',
    Best:'Best Value'
  },
  "Congratulation!":"Congratulation!",
  "You have a Special Offer!":"You have a Special Offer!",
  "You have":"You have",
  "Hours":"Hours",
    "Minutes":"Minutes",
    "Seconds":"Seconds",
   "Nomore":"No more transaction history",
   "reached":"You've reached the end of the list",
   sharefree:{
    educators:"500+ U.S K-12  top educators",
    sessions:"Over 20,000,000+ minutes live sessions",
    parents:"Trusted by 10,000+ parents",
    Match:"20+Subjects Mix and Match",
   },
   Childdialog:{
    Parent:"Dear Parent:",
    advisor:"If you want to add student, please contact our course advisor for assistant！",
    title: "Please contact your exclusive advisor to add a student",
   },
   "Country Code":"Country Code",
   "Please select your country code":"Please select your country code",

   "Sign in":"Sign in",
   "Please use Google Chrome or Microsoft Edge to improve your experience.":"Please use Google Chrome or Microsoft Edge to improve your experience.",
   "Verification Code":"Verification code",
   "Passwordon":"Password",
   "Phone number":"Phone number",
   "Verification code":"Verification code",
   "Password":"Password",
   "Send":"Send",
   "Continue":"Continue",
   "By continuing, you agree to our Terms of Use and Privacy Policy.":"By continuing, you agree to our Terms of Use and Privacy Policy.",
   "By continuing, you agree to our ": "By continuing, you agree to the ",
   "ServiceAgreement": "Terms",
   "and": " & ",
   "PrivacyPolicy": "Privacy",
   "Welcome to Panda Mandarin":"Welcome to Panda Mandarin",
   "Please tell us a little about yourself":"Please tell us a little about yourself",
   "Phone Number":"Phone Number",
   "Kid(s) Nickname":"Kid(s) Nickname",
   "Email address":"Email address",
   "Wechat ID":"Wechat ID",
   "Submit":"Submit",
   "Thank you for choosing us":"Thank you for choosing us",
   "Your Course Adviser will contact you shortly":"Your Course Adviser will contact you shortly",
   "Back":"Back",
   "Please use":"Please use Google Chrome or Microsoft Edge to improve your experience.",
   "Please verify and enter the text in the picture":"Please verify and enter the text in the picture",
   "The Verification Code can not be empty":"The Verification Code can not be empty",
   "Please enter the contents":"Please enter the contents",
   "Success":"submit",
   "Click Refresh Verification Code":"Click Refresh Verification Code",
   "User Does Not Exist":"User does not exists, please try again",
   "Wrong password":"Wrong password, please try again",
   "Dont have an account":"Don’t have an account?",
   "Sign up to get a free lesson":"Sign up to get a free lesson",
   "Congratulations!":"Congratulations!",
    "You have claimed a free trial lesson":"You have claimed a free trial lesson",
   "Our Course Adviser will contact you shortly":"Our Course Adviser will contact you shortly",
  saleCard: {
    title: 'Congratulations on your free Panda Mandarin trial lesson!',
    desc: 'Panda Mandarin offers a leveled Chinese program for ages 3–18. It is systematic, engaging, and effective — ideal for both heritage and beginner learners.',
    cta: 'Scan to add your course adviser on WeChat'
  },
   "Paid Credit":"Paid Credit",
   "Refundable":"Refundable",
   "Reward Credit":"Reward Credit",
   "Non-Refundable":"Non-Refundable",
   "For more information please read":"For more information please read",

}



// WEBPACK FOOTER //
// ./src/i18n/en-US.js